// Gamification Redux Actions
import { createRequestTypes } from "../utils";

// Profile
export const FETCH_GAMIFICATION_PROFILE = createRequestTypes("FETCH_GAMIFICATION_PROFILE");
export const UPDATE_GAMIFICATION_PREFERENCES = createRequestTypes("UPDATE_GAMIFICATION_PREFERENCES");

// XP
export const FETCH_RECENT_XP = createRequestTypes("FETCH_RECENT_XP");
export const FETCH_XP_SUMMARY = createRequestTypes("FETCH_XP_SUMMARY");

// Achievements
export const FETCH_ACHIEVEMENTS = createRequestTypes("FETCH_ACHIEVEMENTS");
export const FETCH_UNLOCKED_ACHIEVEMENTS = createRequestTypes("FETCH_UNLOCKED_ACHIEVEMENTS");

// Challenges
export const FETCH_CHALLENGES = createRequestTypes("FETCH_CHALLENGES");
export const JOIN_CHALLENGE = createRequestTypes("JOIN_CHALLENGE");

// Leaderboards
export const FETCH_GLOBAL_LEADERBOARD = createRequestTypes("FETCH_GLOBAL_LEADERBOARD");
export const FETCH_ORGANIZATION_LEADERBOARD = createRequestTypes("FETCH_ORGANIZATION_LEADERBOARD");

// Skill Tree
export const FETCH_SKILL_TREE = createRequestTypes("FETCH_SKILL_TREE");

// Notifications
export const SHOW_XP_NOTIFICATION = 'SHOW_XP_NOTIFICATION';
export const SHOW_LEVEL_UP_NOTIFICATION = 'SHOW_LEVEL_UP_NOTIFICATION';
export const SHOW_ACHIEVEMENT_NOTIFICATION = 'SHOW_ACHIEVEMENT_NOTIFICATION';
export const CLEAR_GAMIFICATION_NOTIFICATION = 'CLEAR_GAMIFICATION_NOTIFICATION';

// UI State
export const SET_LEADERBOARD_TYPE = 'SET_LEADERBOARD_TYPE';
export const SET_ACHIEVEMENT_FILTER = 'SET_ACHIEVEMENT_FILTER';

// ==================== PROFILE ====================

export const fetchGamificationProfileRequest = () =>
    ({ type: FETCH_GAMIFICATION_PROFILE.REQUEST });

export const fetchGamificationProfileSuccess = (profile) =>
    ({ type: FETCH_GAMIFICATION_PROFILE.SUCCESS, payload: profile });

export const fetchGamificationProfileFailure = (error) =>
    ({ type: FETCH_GAMIFICATION_PROFILE.FAILURE, payload: error });

export const updateGamificationPreferencesRequest = (preferences) =>
    ({ type: UPDATE_GAMIFICATION_PREFERENCES.REQUEST, payload: preferences });

export const updateGamificationPreferencesSuccess = (profile) =>
    ({ type: UPDATE_GAMIFICATION_PREFERENCES.SUCCESS, payload: profile });

export const updateGamificationPreferencesFailure = (error) =>
    ({ type: UPDATE_GAMIFICATION_PREFERENCES.FAILURE, payload: error });

// ==================== XP ====================

export const fetchRecentXPRequest = () =>
    ({ type: FETCH_RECENT_XP.REQUEST });

export const fetchRecentXPSuccess = (transactions) =>
    ({ type: FETCH_RECENT_XP.SUCCESS, payload: transactions });

export const fetchRecentXPFailure = (error) =>
    ({ type: FETCH_RECENT_XP.FAILURE, payload: error });

export const fetchXPSummaryRequest = () =>
    ({ type: FETCH_XP_SUMMARY.REQUEST });

export const fetchXPSummarySuccess = (summary) =>
    ({ type: FETCH_XP_SUMMARY.SUCCESS, payload: summary });

export const fetchXPSummaryFailure = (error) =>
    ({ type: FETCH_XP_SUMMARY.FAILURE, payload: error });

// ==================== ACHIEVEMENTS ====================

export const fetchAchievementsRequest = () =>
    ({ type: FETCH_ACHIEVEMENTS.REQUEST });

export const fetchAchievementsSuccess = (achievements) =>
    ({ type: FETCH_ACHIEVEMENTS.SUCCESS, payload: achievements });

export const fetchAchievementsFailure = (error) =>
    ({ type: FETCH_ACHIEVEMENTS.FAILURE, payload: error });

export const fetchUnlockedAchievementsRequest = () =>
    ({ type: FETCH_UNLOCKED_ACHIEVEMENTS.REQUEST });

export const fetchUnlockedAchievementsSuccess = (achievements) =>
    ({ type: FETCH_UNLOCKED_ACHIEVEMENTS.SUCCESS, payload: achievements });

export const fetchUnlockedAchievementsFailure = (error) =>
    ({ type: FETCH_UNLOCKED_ACHIEVEMENTS.FAILURE, payload: error });

// ==================== CHALLENGES ====================

export const fetchChallengesRequest = () =>
    ({ type: FETCH_CHALLENGES.REQUEST });

export const fetchChallengesSuccess = (challenges) =>
    ({ type: FETCH_CHALLENGES.SUCCESS, payload: challenges });

export const fetchChallengesFailure = (error) =>
    ({ type: FETCH_CHALLENGES.FAILURE, payload: error });

export const joinChallengeRequest = (challengeId) =>
    ({ type: JOIN_CHALLENGE.REQUEST, payload: { challengeId } });

export const joinChallengeSuccess = (progress) =>
    ({ type: JOIN_CHALLENGE.SUCCESS, payload: progress });

export const joinChallengeFailure = (error) =>
    ({ type: JOIN_CHALLENGE.FAILURE, payload: error });

// ==================== LEADERBOARDS ====================

export const fetchGlobalLeaderboardRequest = (leaderboardType, limit = 50, offset = 0) =>
    ({ type: FETCH_GLOBAL_LEADERBOARD.REQUEST, payload: { leaderboardType, limit, offset } });

export const fetchGlobalLeaderboardSuccess = (data) =>
    ({ type: FETCH_GLOBAL_LEADERBOARD.SUCCESS, payload: data });

export const fetchGlobalLeaderboardFailure = (error) =>
    ({ type: FETCH_GLOBAL_LEADERBOARD.FAILURE, payload: error });

export const fetchOrganizationLeaderboardRequest = (orgShortId, leaderboardType = 'org_xp') =>
    ({ type: FETCH_ORGANIZATION_LEADERBOARD.REQUEST, payload: { orgShortId, leaderboardType } });

export const fetchOrganizationLeaderboardSuccess = (data) =>
    ({ type: FETCH_ORGANIZATION_LEADERBOARD.SUCCESS, payload: data });

export const fetchOrganizationLeaderboardFailure = (error) =>
    ({ type: FETCH_ORGANIZATION_LEADERBOARD.FAILURE, payload: error });

// ==================== SKILL TREE ====================

export const fetchSkillTreeRequest = () =>
    ({ type: FETCH_SKILL_TREE.REQUEST });

export const fetchSkillTreeSuccess = (nodes) =>
    ({ type: FETCH_SKILL_TREE.SUCCESS, payload: nodes });

export const fetchSkillTreeFailure = (error) =>
    ({ type: FETCH_SKILL_TREE.FAILURE, payload: error });

// ==================== NOTIFICATIONS ====================

export const showXPNotification = (amount, description) =>
    ({ type: SHOW_XP_NOTIFICATION, payload: { amount, description } });

export const showLevelUpNotification = (level, title) =>
    ({ type: SHOW_LEVEL_UP_NOTIFICATION, payload: { level, title } });

export const showAchievementNotification = (achievement) =>
    ({ type: SHOW_ACHIEVEMENT_NOTIFICATION, payload: achievement });

export const clearGamificationNotification = () =>
    ({ type: CLEAR_GAMIFICATION_NOTIFICATION });

// ==================== UI STATE ====================

export const setLeaderboardType = (leaderboardType) =>
    ({ type: SET_LEADERBOARD_TYPE, payload: leaderboardType });

export const setAchievementFilter = (filter) =>
    ({ type: SET_ACHIEVEMENT_FILTER, payload: filter });
